import type { EmailReminderDbData } from "../../../shared/types";
import BaseWriteApi from "../BaseWriteApi";

export default class EmailRemindersApi extends BaseWriteApi<EmailReminderDbData> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}email_reminders`;
  }
}
